import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { useApplicationRuntimeContext } from '@context/ApplicationRuntimeContext';
import { IFormattedPrice } from '@model';

export const useFormattedPrice = (price: number): IFormattedPrice => {
  const { formatNumber } = useIntl();

  const {
    applicationSettings: {
      primaryCurrency: { decimalPlaces, currencyFormat, currencySymbol },
    },
  } = useApplicationRuntimeContext();

  const formattedPrice = formatNumber(price, {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  }).toString();

  return useMemo(
    () => ({
      price: formattedPrice,
      currencyFormat,
      currencySymbol,
      originalValue: price,
    }),
    [formattedPrice, currencyFormat, currencySymbol, price],
  );
};
